import React from "react"

const QuarterlyRecurrenceDetails = () => (
  <span>
    on Jan 1, Apr 1, Jul 1, and Oct 1.
  </span>
)

export default QuarterlyRecurrenceDetails
